import type * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

/**
 * Validates if all x-coordinates in the provided point groups are numbers
 */
export function hasNumericXValues(
  values: readonly ents.core.display.chart.data.Point.Group[] | undefined,
): boolean {
  return (
    values?.every(value =>
      value.points?.every(point => TypeChecker.isNumber(point.x ?? 0)),
    ) ?? false
  )
}
